<template>
    <div>
        <swb-query-sort-area ref="query_model_ctrl" name="query-sort-area" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="domHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox, Vue} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'

    import finacApi from '../../api/finac'

    import SwbQuerySortArea from '../query/QuerySortArea';
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbQuerySortArea);

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-invoice-voucher-list-select',
        path: '/invoice/voucher/list/for/select',
        desc: '发票单据列表',
        props: {
            settleProofId: {
                type: Number,
                default: null
            },
            buyerRealComCode: {
                type: String,
                default: null
            },
            buyerRealComId: {
                type: Number,
                default: null
            },
            invoiceType: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                confKey: 'swb-invoice-voucher-list',
                domHeight: 500,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: false, //操作列是否固定
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pagination: null,
                pageSizes: getDefaultPageSizes(),
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                invoiceTypeMaps: getEnumMap('invoiceType', 'value2text')
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
        },
        mounted() {
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady: function () {

            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'invoiceType': function (row, colName, colValue, rowIndex, btnName) {
                        return '<span>' + self.invoiceTypeMaps[row.invoiceType] + '</span>'
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        return [];
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log('----- 双击数据行 ----');
                    console.log(row);
                }
            },
            //
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                //
                this.pageNumber = 1;
                this.getInvoiceVoucherList();

            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log('分页 => 第【' + pageNumber + '】页，大小：' + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getInvoiceVoucherList();
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            //获取发票单据列表
            getInvoiceVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if (!Utils.isNoB(this.buyerRealComId)) {
                    filterItems.receiverRealComId = this.buyerRealComId;
                }
                if (Utils.isNoB(this.buyerRealComId) && !Utils.isNoB(this.buyerRealComCode)) {
                    filterItems.receiverRealComCodeX = this.buyerRealComCode;
                }
                if (!Utils.isNoB(this.invoiceType)) {
                    filterItems.invoiceType = this.invoiceType;
                }
                filterItems.collaboState = 3;    // 已收票
                filterItems.relVoucherId = -1;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let msgBoxDlg = MsgBox.loading();
                finacApi.getInvoiceVoucherList(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let invoiceList = result.data.rows;
                        for (let i = 0; i < invoiceList.length; i++) {
                            let invoice = invoiceList[i];
                            invoice.totalAmount = (invoice.totalAmount || 0).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
                            invoice.amount = (invoice.amount || 0).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
                        }
                        let pagination = result.data.pagination;
                        self.pagination = pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        self.renderTable(invoiceList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let selectList = this.getTableSelection() || [];
                let result = {
                    type: 'info'
                };
                if (selectList.length <= 0) {
                    result.type = 'warn';
                    result.message = '请选择发票信息';
                    return result
                }
                result.data = selectList;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/invoiceVoucher/InvoiceVoucherListForSelect.vue